/** 产品名称 */
export const PLATFORM_NAME = '灵彩AI视频辅助工具';

export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api';

export const APP_ENV = process.env.VUE_APP_ENV || 'local';

export const USE_MOCK = process.env.VUE_APP_USE_MOCK === 'true';

export const UPLOAD_MAX_SIZE_MB = 20480;
export const UPLOAD_MAX_SIZE_LABEL = '20GB';

/** 与服务端 aivideoclip.cleanup.video-retention-hours 默认值一致 */
export const VIDEO_RETENTION_HOURS = 24;

export const API_PATHS = {
  health: '/health',
  features: '/config/features',
  uploadInit: '/upload/init',
  uploadChunk: '/upload/chunk',
  uploadComplete: '/upload/complete',
  uploadPresign: '/upload/presign',
  uploadPresignComplete: '/upload/presign/complete',
  fixedDuration: (projectId) => `/videos/${projectId}/segments/fixed-duration`,
  fixedCount: (projectId) => `/videos/${projectId}/segments/fixed-count`,
  highlights: (projectId) => `/videos/${projectId}/highlights`,
  segmentTask: (taskId) => `/segment-tasks/${taskId}`,
  segmentTaskEvents: (taskId) => `/segment-tasks/${taskId}/events`,
  segmentTaskDownload: (taskId) => `/segment-tasks/${taskId}/download`,
  segmentTaskPublishPack: (taskId) => `/segment-tasks/${taskId}/publish-pack`,
  segmentTaskPublishMeta: (taskId) => `/segment-tasks/${taskId}/publish-meta`,
  segmentRefine: (taskId, segmentId) => `/segment-tasks/${taskId}/segments/${segmentId}/refine`,
  segmentFeedback: (taskId, segmentId) => `/segment-tasks/${taskId}/segments/${segmentId}/feedback`,
  projects: '/projects',
  project: (projectId) => `/projects/${projectId}`,
  projectCoverTemplate: (projectId) => `/projects/${projectId}/cover-template`,
  projectCoverFromVideo: (projectId) => `/projects/${projectId}/cover-template/from-video`,
  projectDanmaku: (projectId) => `/projects/${projectId}/danmaku`,
  projectTasks: (projectId) => `/projects/${projectId}/segment-tasks`,
};

export const SEGMENT_POLL_INTERVAL_MS = 1500;
export const SEGMENT_POLL_MAX_WAIT_MS = 60 * 60 * 1000;
export const SEGMENT_POLL_MAX_ATTEMPTS = Math.ceil(
  SEGMENT_POLL_MAX_WAIT_MS / SEGMENT_POLL_INTERVAL_MS,
);
